import { ILevel } from "models";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { actions } from "redux-store";
import { push } from "connected-react-router";
import { useMediaQuery } from "@mui/material";

export const useLevelButton = (level: ILevel) => {
  const dispatch = useDispatch();
  const isTooNarrow = useMediaQuery("(max-width:450px)");

  const onClick = useCallback(() => {
    dispatch(actions.setChosenLevel(level));
    window.location.href = "#/game";
    dispatch(actions.playSound("countdownAudioId"));
    // Precarico l'audio da eseguire alla fine in automatico
    dispatch(actions.playSound("gameOverAudioId", true));
  }, [level, dispatch]);

  return { onClick, isTooNarrow };
};
